module.exports = __webpack_public_path__ + "static/media/chevron-right-blue-ic.61f233bd.svg";